import   React           ,
       { useState        ,
         useEffect       }  from 'react';

import   classNames         from 'classnames';

import   styles             from './ProductCategoryRow.module.scss';

import { ProductCategory }  from '../../../dataTypes/productManagment/types';

import   Field              from '../../widget/inputs/Field';
import   Icon               from '../../widget/images/Icon';
import   Toggle             from '../../widget/inputs/Toggle';

interface ProductCategoryRowProps {
  category           : ProductCategory;
  categorySetLenght  : number;
  onNameChange       : (index: number, newName: string) => void; // (event: React.ChangeEvent<HTMLInputElement>, index: number) => void;
  onArrowClick       : (index: number, direction: 'up' | 'down') => void;
  onDeleteClick      : (category: ProductCategory) => void;
  onVisibilityChange : (index: number, newState: boolean) => void;
}

export const ProductCategoryRow = ({ category           ,
                                     categorySetLenght  ,
                                     onNameChange       ,
                                     onArrowClick       ,
                                     onDeleteClick      ,
                                     onVisibilityChange }: ProductCategoryRowProps) => {

  const [ oldCategoryName  , setOldCategoryName  ] = useState (category.name)
  const [ newCategoryName  , setNewCategoryName  ] = useState (category.name)
  const [ modificationFlag , setModificationFlag ] = useState (false)

  useEffect(() => {

    setOldCategoryName  (category.name)
    setNewCategoryName  (category.name)
    setModificationFlag (false)

  }, [category]);

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    setNewCategoryName ( event.target.value )
    setModificationFlag ( event.target.value !== oldCategoryName )
  }

  const handleNameChangeConfirm = () => {

    onNameChange ( category.rank-1 , newCategoryName )
  }

  return (
    <div className={classNames(styles.row)}>
      <div className={classNames(styles.column, styles.rank)}>{category.rank}</div>
      <div className={classNames(styles.column, styles.name)}>
        <Field type        = "text"
               placeholder = "Nom de la catégorie"
               value       = {category.name}
               onChange    = {handleNameChange}
        />
      </div>
      <div className={classNames(styles.column, styles.nameSaving)}>
        {
         modificationFlag &&
          (
           <Icon name       = "floppyDisk"
                 onClick    = {handleNameChangeConfirm}
		             color      = "var(--color-Icon-FG)"
                 hoverColor = "var(--color-Icon-hover-FG)" />
          )
        }
      </div>
      <div className={classNames(styles.column, styles.actions)}>
        {category.rank > 1 && (
          <Icon name       = "topArrow"
                onClick    = {() => onArrowClick(category.rank-1, 'up')}
		            color      = "var(--color-Icon-FG)"
                hoverColor = "var(--color-Icon-hover-FG)" />
        )}
        {category.rank < categorySetLenght  && (
          <Icon name       = "bottomArrow"
                onClick    = {() => onArrowClick(category.rank-1, 'down')}
		            color      = "var(--color-Icon-FG)"
                hoverColor = "var(--color-Icon-hover-FG)" />
        )}
      </div>
      <div className={classNames(styles.column, styles.delete)}>
        <Icon name       = "trashCan"
              onClick    = {() => onDeleteClick(category)}
		          color      = "var(--color-Icon-FG)"
              hoverColor = "var(--color-Icon-hover-FG)" />
      </div>
      <div className={classNames(styles.column, styles.visibility)}>
        <Toggle checked  = {category.visible}
                form     = "switch"
                onChange = {() => onVisibilityChange(category.rank-1, !category.visible)}
        />
      </div>
    </div>
  );
};

export default ProductCategoryRow;
